module.exports = __webpack_public_path__ + "img/log out.825ddf31.png";